import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalAddonAll: [],
  generalAddon: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalAddonSlice = createSlice({
  name: "generalAddon",
  initialState,
  reducers: {
    setGeneralAddonAll: (state, action) => {
      state.generalAddonAll = action.payload;
    },
    setGeneralAddon: (state, action) => {
      state.generalAddon = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralAddonAll,
  setGeneralAddon,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalAddonSlice.actions;

export default generalAddonSlice.reducer;
